import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { benefitRulesService } from '../services/benefitRulesService'

export function useBenefitRuleMutation() {
  const navigate = useNavigate()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const create = async (payload: Record<string, unknown>) => {
    setIsSubmitting(true)
    setError(null)
    try {
      await benefitRulesService.create(payload)
      navigate('/benefits')
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const detail = err.response?.data?.detail
        setError(typeof detail === 'string' ? detail : 'Error al crear regla de beneficio')
      } else {
        setError('Error al crear regla de beneficio')
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  const update = async (id: number, payload: Record<string, unknown>) => {
    setIsSubmitting(true)
    setError(null)
    try {
      await benefitRulesService.update(id, payload)
      navigate('/benefits')
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const detail = err.response?.data?.detail
        setError(typeof detail === 'string' ? detail : 'Error al actualizar regla de beneficio')
      } else {
        setError('Error al actualizar regla de beneficio')
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  const remove = async (id: number) => {
    setIsSubmitting(true)
    setError(null)
    try {
      await benefitRulesService.delete(id)
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const detail = err.response?.data?.detail
        setError(typeof detail === 'string' ? detail : 'Error al eliminar regla de beneficio')
      } else {
        setError('Error al eliminar regla de beneficio')
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  return { create, update, remove, isSubmitting, error }
}
